import { Divider } from 'antd';
import styled from 'styled-components';

export const FormActions = styled.div`
  display: flex;
  button:first-child {
    margin: 0 0.5rem 0 auto;
  }
`;

export const TaskStepsDivider = styled(Divider)`
  margin: 0.5rem 0;
`;
